/**
 * This file includes the function to parse action. The object instantiating
 * should happen here
 *
 * @auther lampralex
 */

import { getSingleUIProps } from '../dataModelerResources/util';
import { extractInternalAction, extractExternalAction, extractCustomCode } from './actionParser';

function elementParser(element) {
  const action = {
    actionName: element.getAttribute('annotationName') || 'noname',
    internalAction: extractInternalAction(element),
    externalAction: extractExternalAction(element),
    customCode: extractCustomCode(element),
    UIProps: getSingleUIProps(element)
  };
  return action;
}

/**
 * This function receives an id and searches the local storage api to get the
 * service description
 */
function searchServiceById(serviceId) {
  const serviceIndex = serviceId.split(/Project|Block/).filter(Boolean);
  let serviceDesc;
  try {
    serviceDesc = JSON.parse(localStorage.getItem('data'))[serviceIndex[0]].services[0]
      .services_requests[serviceIndex[1]];
  } catch (err) {
    serviceDesc = { error: '' };
  }
  return serviceDesc;
}

function elementServiceParser(element) {
  const actionHttp = elementParser(element);
  const { typeRequest, url } = searchServiceById(element.getAttribute('wabli-service-id'));
  actionHttp.service = { typeRequest, url };
  return actionHttp;
}

export { elementParser, elementServiceParser };
